import { Event } from '../../content/discover/content';

type EventStructuredDataProps = Event;

const EventStructuredData = (props: EventStructuredDataProps) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Event",
          "name": props.title,
          "startDate": props.date,
          "url": props.url,
          ...(props.venue && {
            "location": {
              "@type": "Place",
              "name": props.venue,
              ...(props.venueAddress && {
                "address": {
                  "@type": "PostalAddress",
                  ...(props.venueAddress.streetAddress && { "streetAddress": props.venueAddress.streetAddress }),
                  ...(props.venueAddress.addressLocality && { "addressLocality": props.venueAddress.addressLocality }),
                  ...(props.venueAddress.postalCode && { "postalCode": props.venueAddress.postalCode }),
                  ...(props.venueAddress.addressRegion && { "addressRegion": props.venueAddress.addressRegion }),
                  ...(props.venueAddress.addressCountry && { "addressCountry": props.venueAddress.addressCountry })
                }
              })
            }
          }),
          ...(props.isFree && {
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            }
          })
        })
      }}
    />
  );
};

export default EventStructuredData; 